import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from "react";
import { useMediaQuery } from "react-responsive";
import { ResponsiveImage } from "../../../../components/ResponsiveImage";
import { FlavorFinderBackButton, FlavorFinderNextButton, FlavorFinderSkipButton } from "../Buttons/FlavorFinderButtons";
import { FlavorFinderHeader } from "../Header/FlavorFinderHeader";
import { useFlavorFinderContext } from "../Provider/FlavorFinderContextProvider";
import "./FlavorFinderOptionalQuestion.scss";
export const FlavorFinderOptionalQuestion = ({ question, nextCtaLabel, backCtaLabel, skipCtaLabel, selectionIndicator, hideNextButton = false, }) => {
    const { question: questionDetails, possibleAnswers } = question;
    const { userJourney, setUserJourney, setCurrentView, handlePreviousStepClick, setCurrentQuestionIndex } = useFlavorFinderContext();
    const isMobile = useMediaQuery({ maxWidth: 479 });
    const selectedAnswerIdForCurrentQuestion = userJourney.find((step) => step.question?.question?.id === questionDetails.id);
    const handleNextStepClick = useCallback(() => {
        setCurrentQuestionIndex((prevIndex) => prevIndex + 1);
        setUserJourney([...userJourney, { view: "consent" }]);
        setCurrentView("consent");
    }, [setCurrentView]);
    const handleAnswerSelect = (answerId) => () => {
        const updatedJourney = [...userJourney];
        const currentStepIndex = updatedJourney.findIndex((step) => step.question?.question?.id === questionDetails.id);
        const selectedAnswer = possibleAnswers.find((answer) => answer.id === answerId);
        if (currentStepIndex > -1) {
            updatedJourney[currentStepIndex].answer_id = answerId;
            updatedJourney[currentStepIndex].reference_name = selectedAnswer?.referenceName;
            updatedJourney[currentStepIndex].local_translation = selectedAnswer?.localTranslation;
        }
        else {
            updatedJourney.push({
                view: "optional",
                question: question,
                answer_id: answerId,
                reference_name: selectedAnswer?.referenceName,
                local_translation: selectedAnswer?.localTranslation,
            });
        }
        setUserJourney(updatedJourney);
        if (hideNextButton) {
            handleNextStepClick();
        }
    };
    const findStepIndex = (journey, questionId) => {
        const index = journey.findIndex((step) => step.question?.question?.id === questionId);
        if (index === -1) {
            throw new Error(`Step not found for question ID: ${questionId}`);
        }
        return index;
    };
    const handleSkipClick = useCallback(() => {
        setCurrentQuestionIndex((prevIndex) => prevIndex + 1);
        setUserJourney((prevJourney) => {
            try {
                const updatedJourney = [...prevJourney];
                const currentStepIndex = findStepIndex(updatedJourney, questionDetails.id);
                if (updatedJourney[currentStepIndex]) {
                    delete updatedJourney[currentStepIndex].answer_id;
                }
                return [...updatedJourney, { view: "consent" }];
            }
            catch {
                console.error("Error updating journey");
                return prevJourney;
            }
        });
        setCurrentView("consent");
    }, [questionDetails.id]);
    return (_jsxs("div", { className: "flavorfinder__questions-wrapper flavorfinder__questions-wrapper--additional", "data-testid": "flavor-finder-additional-question", children: [isMobile && _jsx(FlavorFinderBackButton, { onClick: handlePreviousStepClick, label: backCtaLabel }), _jsx("div", { className: "flavorfinder__question-container", children: _jsxs("div", { className: "flavorfinder__question", children: [_jsx(FlavorFinderHeader, { infoText: `${questionDetails.indicatorOverrideLabel}`, children: !isMobile && _jsx(FlavorFinderBackButton, { onClick: handlePreviousStepClick, label: backCtaLabel }) }), _jsxs("div", { className: "flavorfinder__additional-question-content", children: [questionDetails.image ? (_jsx(ResponsiveImage, { alt: questionDetails.alt, largeSrc: questionDetails.image, mediumSrc: questionDetails.mediumImage, smallSrc: questionDetails.smallImage, className: "responsive-image__container" })) : null, _jsxs("div", { className: "flavorfinder__panel", children: [_jsx("h3", { className: "flavorfinder__panel-header", children: questionDetails.title }), selectionIndicator && _jsx("p", { className: "flavorfinder__panel-subheader", children: selectionIndicator }), _jsx("div", { className: "flavorfinder__inputs", children: possibleAnswers.map((answer) => {
                                                return (_jsxs("div", { className: "flavorfinder__input-wrapper", onClick: handleAnswerSelect(answer.id), children: [_jsx("input", { type: "radio", id: answer.id, name: "answerGroup", value: answer.title, checked: answer.id === selectedAnswerIdForCurrentQuestion?.answer_id }), _jsx("label", { htmlFor: answer.id, children: answer.title })] }, answer.id));
                                            }) })] })] }), _jsxs("div", { className: "flavorfinder__footer", children: [_jsx(FlavorFinderNextButton, { onClick: handleNextStepClick, label: nextCtaLabel, disabled: selectedAnswerIdForCurrentQuestion?.answer_id === undefined, hidden: hideNextButton }), _jsx(FlavorFinderSkipButton, { label: skipCtaLabel, onClick: handleSkipClick })] })] }) })] }));
};
//# sourceMappingURL=FlavorFinderOptionalQuestion.js.map